/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Listing_Extra_InfoInputs */

const cs_portals_listing_extra_info = /** @type {(inputs: Portals_Listing_Extra_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav nabídky na portálu`)
};

const en_portals_listing_extra_info = /** @type {(inputs: Portals_Listing_Extra_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal listing status`)
};

/**
* | output |
* | --- |
* | "Portal listing status" |
*
* @param {Portals_Listing_Extra_InfoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_listing_extra_info = /** @type {((inputs?: Portals_Listing_Extra_InfoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Listing_Extra_InfoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_listing_extra_info(inputs)
	return cs_portals_listing_extra_info(inputs)
});